import styled from "@emotion/styled";
import { Affix, Button } from "antd";
import { FC } from "react";
import { useNavigate } from "react-router-dom";
//import { useNavigate } from "react-router-dom";

interface UpdateProductProductProps {
  loading: boolean;
  is_guid: boolean;
  is_inventory: boolean;
}

const UpdateProductProduct : FC<UpdateProductProductProps> = ({ loading, is_guid, is_inventory }) => {
 const navigate = useNavigate();

  return (
    <Affix offsetBottom={0}>
      <WrapperAll>
        <ButtonWrapper>
        <Button
            loading={loading}
            htmlType="reset"
            type="default"
            style={{ width: 200 }}
            onClick={() => navigate(-1)}
            size="large"
          >
            กลับไปหน้าสินค้า
          </Button>
          <Button
            loading={loading}
            htmlType="submit"
            type="primary"
            style={{ width: 200 }}
            size="large"
            disabled={is_inventory}
          >
            อัพเดตสินค้า
          </Button>
        </ButtonWrapper>
      </WrapperAll>
    </Affix>
  );
};

export default UpdateProductProduct;

const ButtonWrapper = styled.div`
  max-width: 250px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  gap: 20px;
`;

const WrapperAll = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 10px;
  background-color: #fff;
  border-radius: 4px;
`;
